import { render } from "./ManualsAndVideos.vue?vue&type=template&id=184c7c06"
import script from "./ManualsAndVideos.vue?vue&type=script&lang=js"
export * from "./ManualsAndVideos.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__